import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import { useAtom, atom } from 'jotai';
import Loader from '../../loader/loader';
import MainComponent from "./main_component";
import { useLocation } from "react-router-dom";
import { logout } from '../../api/api';


const isLoadingAtom = atom(false);

function PersonalInfo({ AuthVerify }) {

    const [isLoading, setIsLoading] = useAtom(isLoadingAtom);
    const location = useLocation();

    if (!location.state) {
        logout();
        window.location.replace("/fcc_login");
    }
    const handleLoading = (set) => {

        setIsLoading(set)
    }

    return (
        <>
            <AuthVerify />
            <div>
                {isLoading === true ? <Loader /> : null}
                <MainComponent handleLoading={handleLoading} />
            </div>
        </>
    );
}


export default PersonalInfo;